module.exports = __webpack_public_path__ + "img/emoji_93.9119b287.png";